import React from "react";

type Props = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  label: string;
};

const Input = ({ onChange, placeholder, label }: Props) => {
  return (
    <div className="text-start">
      <label className="block text-gray-700 text-sm font-bold mb-2">
        {label}
      </label>
      <input
        type="text"
        className="border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:border-blue-500 w-full"
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>
  );
};

export default Input;
